module.exports = __webpack_public_path__ + "static/ohq-product-aef83b6ce0194b5fbdb4055ad45c4dbb.png";